import React, { useEffect } from 'react';
import { changeColorAll } from './../CanvasActions';
import SelectField from './../Form/SelectField';

const FormP2T2 = React.memo((props) => {
    useEffect(() => {
        changeColorAll(props.color);
    }, [props.color]);

    return (
        <form action="">
            <hr />
            <SelectField
                required
                label="Color"
                value={props.color}
                setFunction={props.setColor}
                options={[
                    { value: '1', label: 'Full Color' },
                    { value: '2', label: 'Black and White' },
                ]}
            />
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '1', label: '1' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> Co-branded Electronic Letterhead Download</div>
                <div className="description-list mb-4">
                    <span className="label">Description:</span>
                    <div>Download available as a Word Document format. This is an added convenience for users needing an official letterhead to print or email a letter quickly.</div>
                </div>
            </div>
        </form>
    );
});

export default FormP2T2;
